export const ibeaconFields = [
  {
    label: 'IBEACON',
    key: 'ibeacon',
  }
].map((field) => ({
  ...field,
  isSortable: true,
  showErrorKey: field.key,
  thAttr: {
    style: 'min-width:180px;',
  },
}))
